.footer {
  background: linear-gradient(180deg, var(--color-card) 0%, var(--color-background) 100%);
  border-top: 1px solid var(--color-border);
  padding: 5rem 2rem 3rem;
  width: 100%;
  position: relative;
  overflow: hidden;

  /* Subtle bottom glow - toned down */
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 200px;
    background: radial-gradient(ellipse at bottom, var(--color-primary-soft), transparent 70%);
    pointer-events: none;
  }
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.columns {
  display: grid;
  grid-template-columns: minmax(0, 2fr) repeat(3, minmax(0, 1fr));
  gap: 3rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}

.column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.social {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.brand {
  align-items: flex-start;
  gap: 1rem;
}

.logo {
  font-size: 2.25rem;
  max-width: 100%;

  svg {
    max-width: 100%;
    height: auto;
    width: 6.526em;
  }
}

.columnTitle {
  margin-bottom: 0.5rem;
  opacity: 0.9;
}

.links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  li {
    a {
      color: var(--color-muted);
      text-decoration: none;
      transition: color 0.3s ease;
      font-size: 0.95rem;
      display: inline-block;

      &:hover {
        color: var(--color-primary);
      }
    }
  }
}

.version {
  margin-inline-start: 0.5rem;
  font-size: 0.8em;
  opacity: 0.7;
}

.copyright {
  margin-top: 0.5rem;
  margin-bottom: 0;
}
